import { createPostLogoutReturnPathHelpers } from '@ecrm-msal'

export const {
  getPostLogoutCapturePath,
  getSessionPostLogoutReturnPath,
  isSafeReturnPath,
  setSessionPostLogoutReturnPath,
  clearSessionPostLogoutReturnPath,
} = createPostLogoutReturnPathHelpers('agent_desk_post_logout_return')
